import React from 'react';
import PropTypes from 'prop-types'

const RadioButton = ({label, className, name, value }) => {
  return (
    <label className={`radio-button ${className}`}>
      <input
        name={name}
        value={value}
        type="radio"
      />
      {label && <span>{label}</span>}
    </label>
  );
};

RadioButton.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

RadioButton.defaultProps = {
  label: '',
  className: '',
}

export default RadioButton;
